export function generarNombreArchivo(file) {
   return `${file.path} (${bytesTransformar(file.size)} MBs)`;
}
export function bytesTransformar(bytes) {
   return (bytes / 1048576).toFixed(2);
}
export async function generarMetadata(metaLista) {
   const meta = await metaLista.reduce((ac, itemActual, index) => {
      let auxAc = ac;
      if (index === 1) {
         if (typeof ac === 'string') {
            auxAc = `"${ac}"`;
         }
      }
      if (typeof itemActual === 'string') {
         auxAc = `${auxAc},"${itemActual}"`;
      } else {
         auxAc = `${auxAc},${itemActual}`;
      }
      return auxAc;
   });
   return meta;
}
